var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.999377C7 0.999377 14 0.499803 18.5 0.999377C23 1.49895 25 4.97395 25 8.99938C25 13.0248 23 16.9994 18.5 16.9994C14 16.9994 7 16.9994 7 16.9994",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25.0006C19 25.0006 12 25.5002 7.5 25.0006C3 24.501 1 21.0261 1 17.0006C1 12.9752 3 9.00062 7.5 9.00062C12 9.00062 19 9.00063 19 9.00063",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.9cd5ffff9dc787b2fb7f60e4f32d0de7.svg";
export { ForwardRef as ReactComponent };